import { render, staticRenderFns } from "./ElacTenantsListItem.vue?vue&type=template&id=55bc2ffc"
import script from "./ElacTenantsListItem.vue?vue&type=script&lang=js"
export * from "./ElacTenantsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports